module.exports = __webpack_public_path__ + "media/1fie-d-calend.434881a5.mp3";